import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { Layout } from "../../components";
import { request } from '../../api';
import { Container, Row, Col, Badge, Modal, ModalBody, Button } from "reactstrap";
import { API_HOST } from "../../api/config";

import PhotoAlbum from "react-photo-album";
import "react-photo-album/styles.css";

import "./AlbumPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faDownload, faLink, faStar } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

const downloadFile = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = url.split("/").pop();
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const PhotoModal = ({ photo, isOpen, close }) => {
  const registerDownload = (url) => {
    // TODO
    
    downloadFile(url);
  }

  console.log(photo)

  return (
    <Modal isOpen={isOpen} toggle={close} size="xl">
      <ModalBody className="d-flex flex-column">
        <div className="d-flex p-4">
          {photo && photo.tags.map(tag => (
            <Badge pill style={{ backgroundColor: '#676767' }} className="ms-1 me-1" href={tag.url} target="_blank">
              <div className="d-inline-flex text-white">
                <p className="my-auto mx-2 font-weight-bold">{tag.name}</p>
                {tag.url && <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" />}
              </div>
            </Badge>
          ))}
        </div>
        {photo && photo.featuredPost && <div className="px-4">
            <Badge pill color="instagram" href={photo.featuredPost.url} target="_blank">
              <div className="d-inline-flex p-1 text-white">
                <FontAwesomeIcon icon={faInstagram} size="lg" />
                <p className="my-auto mx-2 font-weight-bold">Featured on Instagram</p>
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" />
              </div>
            </Badge>
          </div>}
        {photo && !photo.finalImage && photo.originalImage && <img className="p-4" src={photo.originalImage.url} />}
        {photo && photo.finalImage && <img className="p-4" src={photo.finalImage.url} />}
        {photo && photo.isFavorite && <div className="d-inline-flex px-4">
            <FontAwesomeIcon icon={faStar} color="gold" size="xl" />
            <p className="my-auto ms-2 text-white" style={{ fontStyle: 'italic' }}>Photographer Favorite</p>
          </div>}
        <div className="d-flex flex-sm-row flex-column p-4">
          {photo && photo.originalImage && <Button color="primary" onClick={() => registerDownload(`${API_HOST}/photography/public/photo/${photo.photoId}/original`)} className="mx-auto my-1 my-sm-0">
            <FontAwesomeIcon icon={faDownload} />{" "}Download Original
          </Button>}
          {photo && photo.finalImage && <Button color="primary" onClick={() => registerDownload(`${API_HOST}/photography/public/photo/${photo.photoId}/final`)} className="mx-auto my-1 my-sm-0">
            <FontAwesomeIcon icon={faDownload} />{" "}Download Final
          </Button>}
        </div>
      </ModalBody>
    </Modal>
  )
}

export const AlbumPage = (props) => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const queryId = searchParams.get('id');

  const [state, setState] = useState({
    loading: false,
    data: null,
    error: null
  })
  const [isOpen, setOpen] = useState(false);
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    if (queryId && state.data) openModal(Number(queryId));
  }, [state]);

  if(!state.loading && !state.data && !state.error) {
    setState(prevState => ({ ...prevState, loading: true }))

    request(`/photography/public/album/${slug}`, null, "GET")
      .then(res => {
        setState(prevState => ({ ...prevState, loading: false, data: res.data }));
      })
      .catch(err => {
        setState(prevState => ({ ...prevState, loading: false, error: err }))
      })
  }

  if (!state.loading && state.error && state.error.status >= 400)
    navigate("/album-not-found");

  console.log(state)

  const getPhotos = () => {
    if ((!state.loading && !state.data) || state.loading) return [];

    return state.data.photos.map((p, idx) => ({
      key: p.photoId,
      src: p.finalImage.url,
      width: p.finalImage.width,
      height: p.finalImage.height,
      isFavorite: p.isFavorite
    }))
  }

  const openModal = id => {
    if (!id) return;

    console.log({ id, state })

    var photo = state.data.photos.find(p => p.photoId == id);

    if (!photo) return;

    setPhoto(photo);
    setOpen(true);
  }

  const closeModal = () => {
    setOpen(false);
  }

  const registerPhotoClick = (key) => {
    request(`/photography/public/photo/${key}/view`, null, "POST")

    openModal(key)
  }

  return (
    <>
      <PhotoModal isOpen={isOpen} close={closeModal} photo={photo} />
      <Layout>
        <Container className="mt-4">
          {state.data && 
          <>
            <Row>
              <h1 className="text-white">{state.data.name}</h1>
            </Row>
            <Row className="mb-4">
              <Col xs="12" className="d-flex">
                {state.data.tags.map((tag, i) => (
                  <Badge pill style={{ backgroundColor: '#676767' }} className="ms-1 me-1" href={tag.url} target="_blank">
                    <div className="d-inline-flex text-white">
                      <p className="my-auto mx-2 font-weight-bold">{tag.name}</p>
                      {tag.url && <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" />}
                    </div>
                  </Badge>
                ))}
              </Col>
            </Row>
            <PhotoAlbum
              layout="rows"
              photos={getPhotos()}
              render={{
                // render custom styled link
                button: ({ className, ...props }) => <button className={`photo-link ${className}`} {...props} />,
                // render image selection icon
                extras: (_, { photo: { selected }, index }) => (
                  <div
                    className="favorite-icon-div"
                  >
                    <FontAwesomeIcon className="favorite-icon" icon={faStar} color="gold" size="xl" />
                  </div>
                ),
              }}
              onClick={({ event, photo }) => registerPhotoClick(photo.key)}
              />
          </>}
        </Container>
      </Layout>
    </>
  )
}